import Service from '@/helpers/service'

export default {
    get(params){
        return Service().get("status-report", {params});
    },
}